module.exports = __webpack_public_path__ + "img/NR0001.72b22e3.webp";